// extracted by mini-css-extract-plugin
module.exports = {"root":"CodeTabs_root__nwOXE","trigger":"CodeTabs_trigger__n7KrQ","link":"CodeTabs_link__ub9Ij","icon":"CodeTabs_icon__a1GTE"};